<template>
  <app-modal id="modal-login" hide-footer>
    <h4 class="text-center">
      {{ t("Sign In") }}
    </h4>

    <form-login />

    <div class="text-center mt-2 mb-4">
      <a v-modal.modal-forgot-password href="#" class="link-dark link-underline" data-bs-dismiss="modal">{{ t("Forgot Password") }}?</a>
    </div>

    <div class="google-auth">
      <div class="text-center mb-2">
        {{ t("Other ways to login") }}
      </div>
      <google-signup-custom :label="t('Sign in with Google')" />
    </div>

    <div class="sign-up mt-4 text-center">
      {{ t("Don't have an account?") }}
      <a v-modal.modal-signup href="#" class="link-dark link-underline" data-bs-dismiss="modal">{{ t("Sign Up") }}</a>
    </div>
  </app-modal>
</template>

<script setup lang="ts">
import AppModal from "@/components/v2/modals/modal";
import FormLogin from "@/components/v2/form-login";
import GoogleSignupCustom from "@/components/google-signup-custom";
import { useI18n } from "vue-i18n";

defineOptions({
  name: "modal-login",
});

const { t } = useI18n();
</script>

<style lang="scss">
@import "./index.scss";
</style>
